// Curated display / serif families for the coming-soon splash's H1 + H2
// headers. Tyler @ Toka feedback 2026-08-25 ("I need a font editor for the
// first page ... the first title is a different font to the other headers")
// — this is what powers the admin picker in ComingSoonEditor.
//
// Values map to a CSS `font-family` STACK (so an offline/loading state
// degrades gracefully to a system serif) AND, where marked as a Google Font,
// the name we hand to the loader. "System default" is a no-op — falls back
// to the venue's own body font.

export type ComingSoonSerif = {
  value: string;
  label: string;
  stack: string;
  googleFamily?: string;
  weights?: readonly number[];
};

export const COMING_SOON_SERIFS: readonly ComingSoonSerif[] = [
  {
    value: "system",
    label: "System default (Didot / Bodoni / Playfair fallback)",
    stack: '"Didot", "Bodoni 72", "Playfair Display", Georgia, "Times New Roman", serif',
  },
  {
    value: "Playfair Display",
    label: "Playfair Display",
    stack: "'Playfair Display', Georgia, serif",
    googleFamily: "Playfair Display",
    weights: [400, 500, 600, 700, 800, 900],
  },
  {
    value: "Fraunces",
    label: "Fraunces (soft / editorial)",
    stack: "'Fraunces', Georgia, serif",
    googleFamily: "Fraunces",
    weights: [400, 500, 600, 700, 800, 900],
  },
  {
    value: "Cormorant Garamond",
    label: "Cormorant Garamond (classic)",
    stack: "'Cormorant Garamond', Georgia, serif",
    googleFamily: "Cormorant Garamond",
    weights: [300, 400, 500, 600, 700],
  },
  {
    value: "DM Serif Display",
    label: "DM Serif Display (bold)",
    stack: "'DM Serif Display', Georgia, serif",
    googleFamily: "DM Serif Display",
    weights: [400],
  },
  {
    value: "Bodoni Moda",
    label: "Bodoni Moda (fashion)",
    stack: "'Bodoni Moda', Georgia, serif",
    googleFamily: "Bodoni Moda",
    weights: [400, 500, 600, 700, 800, 900],
  },
  {
    value: "Libre Bodoni",
    label: "Libre Bodoni (Toka default)",
    stack: "'Libre Bodoni', Georgia, serif",
    googleFamily: "Libre Bodoni",
    weights: [400, 500, 600, 700],
  },
] as const;

export function serifStackFor(value: string | null | undefined): string {
  const match = COMING_SOON_SERIFS.find((f) => f.value === value);
  return match?.stack ?? COMING_SOON_SERIFS[0].stack;
}

export function serifGoogleFamilyFor(
  value: string | null | undefined,
): { family: string; weights: readonly number[] } | null {
  const match = COMING_SOON_SERIFS.find((f) => f.value === value);
  if (!match?.googleFamily) return null;
  return { family: match.googleFamily, weights: match.weights ?? [400, 500, 600, 700] };
}
